/**
 * Helpers for Supabase email-confirm / recovery / magic-link callbacks.
 * Confirmation links land with either:
 * - hash tokens: #access_token=...&type=signup
 * - query errors: ?error=...&error_description=...
 * - PKCE code: ?code=...
 */

export function hasAuthCallbackParams(search = window.location.search, hash = window.location.hash): boolean {
  const params = new URLSearchParams(search);
  if (params.has('code') || params.has('token_hash') || params.has('error') || params.has('error_description')) {
    return true;
  }
  const h = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!h) return false;
  const hashParams = new URLSearchParams(h);
  return (
    hashParams.has('access_token') ||
    hashParams.has('refresh_token') ||
    hashParams.has('type') ||
    hashParams.has('error') ||
    hashParams.has('error_code')
  );
}

export function getAuthCallbackType(hash = window.location.hash): string | null {
  const h = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!h) return null;
  return new URLSearchParams(h).get('type');
}

export function getAuthCallbackError(
  search = window.location.search,
  hash = window.location.hash
): string | null {
  const query = new URLSearchParams(search);
  const fromQuery = query.get('error_description') || query.get('error');
  if (fromQuery) return decodeURIComponent(fromQuery.replace(/\+/g, ' '));

  const h = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!h) return null;
  const hashParams = new URLSearchParams(h);
  const fromHash = hashParams.get('error_description') || hashParams.get('error');
  return fromHash ? decodeURIComponent(fromHash.replace(/\+/g, ' ')) : null;
}

/** Safe post-auth landing path — never wipe callback params before session is ready. */
export function cleanAuthCallbackUrl(path = '/dashboard'): void {
  window.history.replaceState({}, '', path);
}
